import React from 'react'
import style from '../../styles/components/input.module.scss'

type LabelProps = React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>

const Label = ({ className, ...props }: LabelProps) => {
    return <label className={`${style.label} ${className || ''}`} {...props}>{props.children}</label>
}

export default Label